"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CommonOrderEstimates = void 0;
var _react = _interopRequireWildcard(require("react"));
var _reactI18next = require("react-i18next");
var _APLabelWithText = _interopRequireDefault(require("../../common/APLabelWithText"));
var _config = _interopRequireDefault(require("../../../config"));
var _reactRedux = require("react-redux");
var _instrumentPositionSelectors = require("../../../redux/selectors/instrumentPositionSelectors");
var _numberFormatter = require("../../../helpers/numberFormatter");
var _orderEntrySelector = require("../../../redux/selectors/orderEntrySelector");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
var hideFees = !!_config["default"].global.hideFees;
var OrderNetItem = /*#__PURE__*/(0, _react.memo)(function (props) {
  var _useTranslation = (0, _reactI18next.useTranslation)('order'),
    t = _useTranslation.t;
  var orderNet = (0, _reactRedux.useSelector)(function (state) {
    return (0, _orderEntrySelector.selectOrderNet)(state, props);
  });
  return /*#__PURE__*/_react["default"].createElement(_APLabelWithText["default"], {
    label: t('Net Receiving'),
    text: orderNet,
    customClass: props.baseClass
  });
});
OrderNetItem.displayName = 'OrderNetItem';
var OrderFeeItem = /*#__PURE__*/(0, _react.memo)(function (props) {
  var _useTranslation2 = (0, _reactI18next.useTranslation)('order'),
    t = _useTranslation2.t;
  var orderFee = (0, _reactRedux.useSelector)(function (state) {
    return (0, _orderEntrySelector.selectOrderFee)(state, props);
  });
  return /*#__PURE__*/_react["default"].createElement(_APLabelWithText["default"], {
    label: t('Fees'),
    customClass: props.baseClass,
    text: orderFee
  });
});
OrderFeeItem.displayName = 'OrderFeeItem';
var OrderTotalItem = /*#__PURE__*/(0, _react.memo)(function (_ref) {
  var baseClass = _ref.baseClass,
    formName = _ref.formName;
  var _useTranslation3 = (0, _reactI18next.useTranslation)('order'),
    t = _useTranslation3.t;
  var instrument = (0, _reactRedux.useSelector)(_instrumentPositionSelectors.selectedInstrumentSelector);
  var orderTotal = (0, _reactRedux.useSelector)(function (state) {
    return (0, _orderEntrySelector.orderTotalSelector)(state, {
      formName: formName
    });
  });
  return /*#__PURE__*/_react["default"].createElement(_APLabelWithText["default"], {
    label: t('Order Total'),
    text: "".concat(instrument.Product2Symbol, " ").concat((0, _numberFormatter.formatNumberToLocale)(orderTotal, instrument.Product2Symbol)),
    customClass: baseClass
  });
});
OrderTotalItem.displayName = 'OrderTotalItem';
var CommonOrderEstimates = exports.CommonOrderEstimates = /*#__PURE__*/(0, _react.memo)(function (props) {
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, !hideFees && /*#__PURE__*/_react["default"].createElement(OrderFeeItem, props), !hideFees && /*#__PURE__*/_react["default"].createElement(OrderNetItem, props), /*#__PURE__*/_react["default"].createElement(OrderTotalItem, props));
});
CommonOrderEstimates.displayName = 'CommonOrderEstimates';